import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';
import _noop from 'lodash/noop';
import cn from 'classnames';
// eslint-disable-next-line import/no-named-as-default
import Search from 'components/Search';
import Button from 'components/Button';
import SortingMenu from 'components/SortingMenu';
// eslint-disable-next-line import/no-named-as-default
import FilterMenu from 'components/FilterMenu';
import AnnotationDrawer from 'components/MatchedAnnotationDrawer';
import { sortOptionType, filterOptionsType, annotationType } from 'types';
import termOptions from 'constants/termOptions';
import ImportExportDropdown from '../ImportExportDropdown';

import './style.scss';

export default class ItemHeaderOptions extends Component {
  static propTypes = {
    getItems: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    modelName: PropTypes.string.isRequired,
    onExport: PropTypes.func.isRequired,
    onMergeImport: PropTypes.func.isRequired,
    onReplaceImport: PropTypes.func.isRequired,
    onSearchItems: PropTypes.func.isRequired,
    annotationsGotLoaded: PropTypes.bool,
    annotationsIsLoading: PropTypes.bool,
    atLeastOneIsUnChecked: PropTypes.bool,
    excludeAll: PropTypes.bool,
    filterItems: PropTypes.func,
    filterOptions: PropTypes.arrayOf(filterOptionsType),
    hasFilterMatchedMenu: PropTypes.bool,
    hasFilterMenu: PropTypes.bool,
    hasGroups: PropTypes.bool,
    hasLeftSubHeader: PropTypes.bool,
    hasSelectedTestSet: PropTypes.bool,
    hasSortingMenu: PropTypes.bool,
    isSearchActive: PropTypes.bool,
    leftSubHeader: PropTypes.node,
    matchedAnnotations: PropTypes.arrayOf(annotationType),
    openCreateGroupModal: PropTypes.func,
    openNewModal: PropTypes.func,
    reverseSearch: PropTypes.bool,
    searchTerm: PropTypes.string,
    selectedSortOption: sortOptionType,
    sortIconClassName: PropTypes.string,
    sortOptions: PropTypes.arrayOf(sortOptionType),
    subHeaderLayout: PropTypes.string,
    toggleAll: PropTypes.func,
    toggleAnnotation: PropTypes.func,
    onSearchEnter: PropTypes.func,
    onToggleStatus: PropTypes.func,
  };

  static defaultProps = {
    subHeaderLayout: 'right',
    sortOptions: [],
    filterOptions: [],
    matchedAnnotations: [],
    hasSortingMenu: false,
    hasFilterMenu: false,
    filterItems: _noop,
    hasLeftSubHeader: false,
    reverseSearch: false,
    isSearchActive: false,
    hasFilterMatchedMenu: false,
    annotationsIsLoading: false,
    hasGroups: false,
    annotationsGotLoaded: false,
  };

  shouldComponentUpdate(nextProps) {
    return !_isEqual(nextProps, this.props);
  }

  handleOpenModal = () => {
    const { openNewModal } = this.props;
    openNewModal();
  };

  renderButton() {
    const { modelName } = this.props;

    if (!termOptions[modelName].create) {
      return null;
    }
    return (
      <Button
        isSmall
        data-test="create-context-rule-button"
        type="button"
        onClick={this.handleOpenModal}
      >
        {termOptions[modelName].buttonClassName && (
          <i className={termOptions[modelName].buttonClassName} />
        )}
        <span data-test="create-rule-button">
          {termOptions[modelName].create}
        </span>
      </Button>
    );
  }

  renderGroupButton() {
    const { modelName, openCreateGroupModal } = this.props;
    return (
      <Button
        isOutlined
        isSmall
        data-test="create-rule-group"
        type="button"
        onClick={openCreateGroupModal}
      >
        {termOptions[modelName].buttonIconClassName && (
          <i className={termOptions[modelName].buttonIconClassName} />
        )}
        <span>{termOptions[modelName].group.create}</span>
      </Button>
    );
  }

  renderHeaderOptions() {
    const {
      searchTerm,
      modelName,
      items,
      onExport,
      onMergeImport,
      onReplaceImport,
      reverseSearch,
      isSearchActive,
      onSearchEnter,
      onToggleStatus,
      onSearchItems,
      hasGroups,
    } = this.props;
    const termOption = termOptions[modelName];
    return (
      <div styleName="item-header">
        <div styleName="item-header__title">
          <span className={`icon icon-${termOption.iconClassName}`} />
          {termOption.title}
        </div>
        <div styleName="item-header__right-block">
          <Search
            getItems={onSearchItems}
            isActive={isSearchActive}
            isReversed={reverseSearch}
            itemsCount={items.length}
            placeholder={termOption.search}
            searchTerm={searchTerm}
            onEnter={onSearchEnter}
            onToggleStatus={onToggleStatus}
          />
          {hasGroups && this.renderGroupButton()}
          {this.renderButton()}
          <ImportExportDropdown
            modelName={termOption.title}
            onExport={onExport}
            onMergeImport={onMergeImport}
            onReplaceImport={onReplaceImport}
          />
        </div>
      </div>
    );
  }

  renderSubHeaderOptions() {
    const {
      items,
      modelName,
      getItems,
      subHeaderLayout,
      hasSortingMenu,
      sortOptions,
      selectedSortOption,
      sortIconClassName,
      hasFilterMenu,
      filterOptions,
      filterItems,
      hasLeftSubHeader,
      leftSubHeader,
      hasSelectedTestSet,
      annotationsGotLoaded,
      matchedAnnotations,
      excludeAll,
      atLeastOneIsUnChecked,
      toggleAll,
      toggleAnnotation,
      hasFilterMatchedMenu,
      annotationsIsLoading,
    } = this.props;
    const newFilterOptions =
      hasSelectedTestSet && hasSelectedTestSet
        ? filterOptions
        : filterOptions.slice(1);
    return (
      <div
        styleName={cn('item-subheader', {
          [subHeaderLayout]:
            hasSortingMenu || hasFilterMenu || hasLeftSubHeader,
        })}
      >
        {hasLeftSubHeader && (
          <div styleName="item-left-subheader">{leftSubHeader}</div>
        )}
        <div styleName="item-right-subheader">
          {hasFilterMatchedMenu && (
            <FilterMenu
              annotationsIsLoading={annotationsIsLoading}
              filterOptions={newFilterOptions}
              modelName={modelName}
              onFilter={filterItems}
            />
          )}
          {hasFilterMenu && (
            <FilterMenu
              filterOptions={filterOptions}
              modelName={modelName}
              onFilter={filterItems}
            />
          )}
          {hasSortingMenu && (
            <SortingMenu
              hasIconuserRanAnnotations
              getItems={getItems}
              iconClassName={sortIconClassName}
              items={items}
              options={sortOptions}
              selectedSortOption={selectedSortOption}
            />
          )}
          {hasSelectedTestSet && annotationsGotLoaded && (
            <AnnotationDrawer
              atLeastOneIsUnChecked={atLeastOneIsUnChecked}
              excludeAll={excludeAll}
              matchedAnnotations={matchedAnnotations}
              toggleAll={toggleAll}
              toggleAnnotation={toggleAnnotation}
            />
          )}
        </div>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderHeaderOptions()}
        {this.renderSubHeaderOptions()}
      </React.Fragment>
    );
  }
}
